exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graph-container[data-v-e73a6902] {\n  height: 500px;\n}\n", ""]);

// exports
